import Toggle, {Size} from '@jetbrains/ring-ui/components/toggle/toggle'
import React, {memo} from 'react'

import SettingsBlock from '../../../../SettingsBlock/SettingsBlock'

import useJobCheckoutWorkingDirectoriesOnly from './JobCheckoutWorkingDirectoriesOnly.hooks'
import type {JobCheckoutWorkingDirectoriesOnlyProps} from './JobCheckoutWorkingDirectoriesOnly.types'

import styles from './JobCheckoutWorkingDirectoriesOnly.css'

function JobCheckoutWorkingDirectoriesOnly({jobId}: JobCheckoutWorkingDirectoriesOnlyProps) {
  const {handlerCheckoutWorkingDirectoriesOnlyToggle, isCheckoutWorkingDirectoriesOnly} =
    useJobCheckoutWorkingDirectoriesOnly(jobId)

  return (
    <SettingsBlock id={'working-directory'} title={'Working Directory'} collapsible>
      <Toggle
        onChange={handlerCheckoutWorkingDirectoriesOnlyToggle}
        className={styles.trigger}
        size={Size.Size16}
        checked={isCheckoutWorkingDirectoriesOnly}
      >
        {'Checkout working directories only'}
      </Toggle>
    </SettingsBlock>
  )
}

export default memo<JobCheckoutWorkingDirectoriesOnlyProps>(JobCheckoutWorkingDirectoriesOnly)
